"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));
var _imageStrikethrough = _interopRequireDefault(require("@ingka/ssr-icon/paths/image-strikethrough"));
var _image = _interopRequireDefault(require("@ingka/ssr-icon/paths/image"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Image = _ref => {
  let {
    src,
    alt,
    className,
    prefix,
    srcSet,
    sizes,
    loading,
    fallback,
    ...otherProps
  } = _ref;
  const [error, setError] = (0, _react.useState)(false);
  const classes = (0, _classnames.default)(`${prefix}image`, (error || fallback) && `${prefix}image--fallback`, className);
  const onError = () => {
    setError(true);
  };
  (0, _react.useEffect)(() => {
    if (src) {
      setError(false);
    }
  }, [src]);
  let paths = _image.default;
  if (error) {
    paths = _imageStrikethrough.default;
  }
  const image = _react.default.createElement("img", _extends({
    className: !error && !fallback ? classes : undefined,
    onError: onError,
    alt: alt,
    src: src,
    srcSet: srcSet,
    sizes: sizes,
    loading: loading
  }, otherProps));
  return error || fallback ? _react.default.createElement("span", {
    className: classes
  }, _react.default.createElement(_ssrIcon.default, {
    paths: paths,
    className: `${prefix}image__icon`,
    prefix: prefix
  }), image) : image;
};
Image.defaultProps = {
  prefix: '',
  loading: 'lazy'
};
var _default = Image;
exports.default = _default;